import React from 'react';
import { CheckIcon } from 'lucide-react';
import { packageHighlights } from '../../data/packageHighlights';
import type { Stat } from '../../types/landing';
type PackageHighlightsProps = {
  stats: Stat[];
};
export function PackageHighlights({
  stats
}: PackageHighlightsProps) {
  return <section className="mx-auto mt-10 max-w-5xl px-6" data-id="element-27" data-mp="2uf9r4c7w70ww">
      <h2 className="text-center font-display text-lg italic text-ink" data-id="element-28" data-mp="2ugur4hcz7c25">
        Everything handled, one package
      </h2>
      <ul className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-5" data-id="element-29" data-mp="2zcs2e99dts82">
        {packageHighlights.map(item => <li key={item} className="flex items-start gap-2" data-id="element-30" data-mp="393waqq4jyetx">
            <CheckIcon className="mt-0.5 h-3 w-3 shrink-0 text-ink/70" aria-hidden="true" data-id="element-31" data-mp="396s6c7sxgrf7" />
            <span className="font-body text-[13px] leading-snug text-ink/80" data-id="element-32" data-mp="3e5lk81c4mkfw">{item}</span>
          </li>)}
      </ul>

      <dl className="mt-6 grid grid-cols-2 gap-y-5 bg-sand px-4 py-5 md:grid-cols-5 md:gap-y-0" data-id="element-33" data-mp="3n472rwhllzgo">
        {stats.map((stat, i) => <div key={stat.label} className={`flex flex-col items-center text-center ${i > 0 ? 'md:border-l md:border-ink/15' : ''}`} data-id="element-34" data-mp="14z1m0nk6mkjd" data-mpi={i}>
            <dt className="order-2 mt-1 font-sans text-[8px] font-medium uppercase tracking-[0.25em] text-ink/70" data-id="element-35" data-mp="vyd9jxafss8l">
              {stat.label}
            </dt>
            <dd className="order-1 font-display text-2xl text-ink" data-id="element-36" data-mp="1olzmvx9gvb8n">{stat.value}</dd>
          </div>)}
      </dl>
    </section>;
}